import { RequestsMap } from 'modules/stats/components/RequestsMap';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { WidgetSection } from '../WidgetSection';
import { trafficMapTranslation } from './translation';
import { useStats } from '../StatsProvider';

export const TrafficMap = () => {
  const { countriesByTraffic, loading } = useStats();

  const { keys, t } = useTranslation(trafficMapTranslation);

  return (
    <WidgetSection title={t(keys.title)}>
      <RequestsMap
        countries={countriesByTraffic}
        dataType="traffic"
        loading={loading}
      />
    </WidgetSection>
  );
};
